"use strict";

exports.__esModule = true;
exports["default"] = exports.ImageContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["alignItems", "justifyContent", "imageSrc"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ImageContainer = (0, _styledComponents["default"])(_primitives["default"].Image).withConfig({
  displayName: "flexible-image__ImageContainer",
  componentId: "sc-jq21y1-0"
})(["max-width:100%;"]);
exports.ImageContainer = ImageContainer;
var propTypes = {
  /** Flex alignment */
  alignItems: _propTypes.string,

  /** image source string */
  imageSrc: _propTypes.string,

  /** Justify, a string  which represents the content centers between the left and right edges. */
  justifyContent: _propTypes.string
};
var defaultProps = {
  alignItems: "center",
  justifyContent: "center"
};

var FlexibleImage = function FlexibleImage(_ref) {
  var alignItems = _ref.alignItems,
      justifyContent = _ref.justifyContent,
      imageSrc = _ref.imageSrc,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return imageSrc ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    justifyContent: justifyContent
  }, props), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: alignItems
  }, /*#__PURE__*/_react["default"].createElement(ImageContainer, {
    src: imageSrc
  }))) : null;
};

FlexibleImage.propTypes = propTypes;
FlexibleImage.defaultProps = defaultProps;
FlexibleImage.displayName = "Modules.FlexibleImage)";
var _default = FlexibleImage;
exports["default"] = _default;